export default __webpack_public_path__ + "static/media/feature_3.854a07bb.png";